import { NameIdPair } from "./nameIdPair";
import { PageableObject } from "./pageableObject";
import { Sort } from "./sort";

export enum ScanType {
  SUPPLY_CHAIN = "Supply Chain",
}

export enum ScanStatus {
  INITIATED = "INITIATED",
  COMPLETED = "COMPLETED",
  PROCESSING = "PROCESSING",
  IMPORTING = "IMPORTING",
  FAILED = "FAILED",
}

export interface ScanSummary {
  id: number | null;
  uniqueDisplayId: string | null;
  uniqueDisplayNum: number | null;
  createdAt: Date | null;
  scanStatus: ScanStatus;
  product: NameIdPair;
  subproduct: NameIdPair;
  environment: string;
  tool: string;
  findings: ScanFindings;
  scanType: string[];
  tags: string[] | null;
  scanIdentifier: string | null;
  uploadedBy: string | null;
  scanDate: Date | null;
  expectedFindings: number | null;
  fileName: string | null;
  errorMessage: string | null;
  triggerby: any;
}

export interface ScanSummaryListDTO {
  content: ScanSummary[];
  empty?: boolean;
  first?: boolean;
  last?: boolean;
  number?: number;
  numberOfElements?: number;
  pageable?: PageableObject;
  size?: number;
  sort?: Sort;
  totalElements?: number;
  totalPages?: number;
}

export interface ScanFindingsType {
  name: string;
  count: number;
  severity: {
    Low: number;
    High: number;
    Info: number;
    Medium: number;
    Critical: number;
  };
}

export interface ScanFindings {
  resolvedFindings: ScanFindingsType;
  localDuplicateFindings: ScanFindingsType;
  duplicateFindings: ScanFindingsType;
  newFindings: ScanFindingsType;
  totalFindings: ScanFindingsType;
}
